/*
 *
 *   reducer
 *
 */
import produce from "immer"

import {
  LOAD_NOT_APPLICABLE_SUCCESS,
  LOAD_NOT_APPLICABLE_ERROR,
 
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,



} from "./constants"

const initialState = {
  applicable_data: [],
  record: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
 

  
}

export default function Reducer(
  state = initialState,
  { type, applicable_data, recordsMetaData = {},error, }
) {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_NOT_APPLICABLE_SUCCESS:
        draft.applicable_data = applicable_data
        draft.error = false
        draft.success = false
        break

      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData
        draft.error = false
        draft.success = false
        break
  
      case LOAD_NOT_APPLICABLE_ERROR:
 
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      case LOAD_RECORDS_META_DATA_ERROR:
        draft.error = error
        draft.success = false
        break
    }
  })
}
